import { Joinus } from "../joinus/Joinus";
import { Footer } from "../footer/Footer";
import { Header } from "../../header/Header";
import { ServicesShowcaseChild } from "../service/ServicesShowcaseChild";
import missionImage from "../../assets/mission.jpeg";

export const Child = () => {
  return (
    <div>
      <Header />

      <section className="relative overflow-hidden bg-gradient-to-br from-brand-900 via-brand-800 to-sea-800 py-20 sm:py-24">
        <div className="pointer-events-none absolute -left-20 top-0 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-20 bottom-0 h-64 w-64 rounded-full bg-sea-400/20 blur-3xl" />
        <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-brand-200">
            Our Services
          </span>
          <h1 className="mt-4 font-display text-5xl font-semibold text-white sm:text-6xl">
            Child Therapy
          </h1>
        </div>
      </section>

      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
          <div className="relative mx-auto w-full max-w-lg">
            <div className="absolute inset-0 -rotate-2 rounded-[2rem] bg-brand-100" />
            <img
              src={missionImage}
              alt="Child therapy session"
              className="relative w-full rounded-[2rem] object-cover shadow-soft"
            />
          </div>
          <div>
            <h2 className="font-display text-3xl font-semibold text-slate-900 sm:text-4xl">
              Gentle support for growing minds
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-slate-600">
              A lot of children are struggling with the emotional ,behavioral
              and developmental challenges without proper attention. A child
              therapy is designed in a specific manner so that the techniques
              may engage and support the child. it is typically for the
              children who are under the age of 18. it also comprises managing
              their behavioural, emotional ,Social and sometimes cognitive
              aspects This therapy focuses on their hypersensitivity and their
              reactions as well. it is designed to address other aspects of
              children too for example school related difficulties ,learning
              related difficulties and IQ related difficulties.
            </p>
          </div>
        </div>
      </section>

      <ServicesShowcaseChild />
      <Joinus />
      <Footer />
    </div>
  );
};
